module.exports = __webpack_public_path__ + "img/case_banner2.244def7b.png";